import { LookupAddress } from '../../event/models/lookup-address';
import { LookupContact } from '../../event/models/lookup-contact';
import { Record } from 'immutable';

const PropertyLookupDetailRecord = Record({
  chain: null,
  brand: null,
  propertyId: null,
  name: null,
  contact: new LookupContact({}),
  address: new LookupAddress({})
});

export class PropertyLookupDetail extends PropertyLookupDetailRecord {
  chain: string;
  brand: string;
  propertyId: string;
  name: string;
  contact: LookupContact;
  address: LookupAddress;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/models/property-lookup-detail.ts